// email
export const ERR_EMAIL_REQUIRED = "Email address is required.";
export const ERR_EMAIL_INVALID = "Please enter a valid email address.";

// phone
export const ERR_PHONE_INVALID = "Please enter a valid phone number.";
export const ERR_DISPATCH_PHONE_INVALID = "Please enter a valid dispatch phone number.";
export const ERR_DRIVER_PHONE_INVALID = "Please enter a valid driver phone number.";
export const ERR_PHONE_REQUIRED_FOR_RESEND =
   "Please enter a valid phone number before resending the code.";

// consent
export const ERR_SMS_CONSENT_REQUIRED =
   "Please consent to receive text messages before submitting.";
export const ERR_DATA_CONSENT_REQUIRED =
   "Please consent to data collection and processing before submitting.";

// form flow (driver/dispatch)
export const ERR_MISSING_DRIVER_ID =
   "Missing required parameters. Please use the link provided in your text message.";
export const ERR_VERIFY_LOCATION_FIRST =
   "Please click the Verify My Location button before submitting.";
export const ERR_EMPTY_FIELDS_REQUIRED = "Please fill in the Empty Time and Empty Location fields.";
export const ERR_UPLOAD_REQUIRED_DOCS =
   "Please upload all required documents: Truck Photo, Cab Card.";
export const ERR_MISSING_CONVERSATION_ID =
   "Missing conversation ID. This form must be accessed through a valid dispatch conversation link.";

// submission/general
export const ERR_SUBMIT_FAILED = "Failed to submit form. Please try again.";
export const ERR_DUPLICATE_SUBMISSION =
   "You have already submitted verification for this driver. Please check your messages for the identity verification link.";
export const ERR_SUBMISSION_LIMIT = "This driver has already submitted verification.";
export const ERR_REQUIRED_FIELDS = "Please fill in all required fields";

// geolocation
export const GEO_NOT_SUPPORTED = "Geolocation is not supported by your browser.";
export const GEO_PERMISSION_DENIED = "Location permission was denied.";
export const GEO_UNAVAILABLE = "Location unavailable. Please try again.";
export const GEO_TIMEOUT = "Location request timed out. Please try again.";
export const GEO_HTTPS_REQUIRED =
   "Location requires HTTPS. Please use the link provided in your text message.";

// auth/login/signup
export const ERR_LOGIN_FAILED = "Login failed. Please try again.";
export const ERR_CREATE_ACCOUNT_FAILED = "Failed to create account. Please try again.";
export const ERR_RESEND_CODE_FAILED = "Failed to resend code. Please try again.";
export const ERR_ENTER_6_DIGIT_CODE = "Please enter the complete 6-digit code";
export const ERR_PASSWORD_MIN_LENGTH = "Password must be at least 8 characters long.";
export const ERR_PASSWORD_REQUIREMENTS = "Please fix the password requirements";
export const ERR_PASSWORDS_DO_NOT_MATCH = "Passwords do not match";
export const ERR_INVALID_VERIFICATION_CODE = "Invalid verification code. Please try again.";

// helpers (dynamic)
export const errAdditionalDriverPhoneInvalid = (n) =>
   `Please enter a valid phone number for Additional Driver ${n}.`;
